import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M22 21.857v-2a4.002 4.002 0 0 0-3-3.874M15.5 4.148a4.001 4.001 0 0 1 0 7.418M17 21.857c0-1.864 0-2.796-.305-3.53a4 4 0 0 0-2.164-2.165c-.735-.305-1.667-.305-3.531-.305H8c-1.864 0-2.796 0-3.53.305a4 4 0 0 0-2.166 2.164C2 19.061 2 19.993 2 21.857m11.5-14a4 4 0 1 1-8 0 4 4 0 0 1 8 0z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }